module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Shield-protected-8276b0ce96bc264d3f2456b5e6cead1a.svg";